module.exports = __webpack_public_path__ + "static/media/camille_carter.dcb8fd89.png";